import {Authorize} from '../authentication/containers';
import React from 'react';
import {roles} from '../authentication/constants';
import {UsersPage} from './containers';
import {IndexRedirect, Route} from 'react-router';

export default (
  <Route path="admin" roles={[roles.ADMIN]} component={Authorize} />
);



// WEBPACK FOOTER //
// ./app/features/users/routes.js